import React from 'react';
import PropTypes from 'prop-types';
import { ButtonWithIcon } from '@els/els-react--button';
import { QUICK_SEARCH_STRUCTURE_UID } from '@Pages/QuickSearch/QuickSearchConstants';
import { StructureOptionsBadges } from '@Containers/StructureOptions';

const STRUCTURE_OPTIONS_DESCRIPTION_ID = `${QUICK_SEARCH_STRUCTURE_UID}-search-description`;

function PromptStructureAttachment({ structurePreview, structureName, onClear, onEdit, removeButtonRef }) {
  const handleClear = (event) => {
    event.stopPropagation();
    onClear();
  };

  const altText = (() => {
    if (!structureName) {
      return 'Preview of drawn structure';
    }

    const structureType = structureName.isLinearFormula ? 'linear formula' : 'chemical structure';
    const structureValue = structureName.isLinearFormula ? structureName.name : structureName.name || structureName;

    return structureValue ? `Preview of ${structureType}: ${structureValue}` : `Preview of ${structureType}`;
  })();

  return (
    <div className="quick-search-prompt-input__attachment">
      <div className="quick-search-prompt-input__attachment-card" onClick={onEdit} role="presentation">
        <div role="group" className="u-els-height-1o1">
          <div className="quick-search-prompt-input__attachment-actions">
            <ButtonWithIcon
              aria-label="Remove drawn structure"
              className="quick-search-prompt-input__attachment-clear"
              data-e2e="e2e-build-query-structureDrawing-clear-button"
              iconOnly
              iconRight
              linkIconSize="s"
              onClick={handleClear}
              onKeyDown={(event) => event.stopPropagation()}
              ref={removeButtonRef}
              size="small"
              sprite="Close"
              type="link">
              Clear quick search structure
            </ButtonWithIcon>
          </div>
          <div className="quick-search-prompt-input__attachment-image-wrap u-els-height-1o1">
            <img
              alt={altText}
              className="quick-search-prompt-input__attachment-image"
              data-e2e="e2e-build-query-structure-drawing-image"
              src={structurePreview}
            />
          </div>
          <div className="quick-search-prompt-input__attachment-badges">
            <span id={STRUCTURE_OPTIONS_DESCRIPTION_ID} className="u-els-hide-visually">
              Edit how the structure should be searched
            </span>
            <StructureOptionsBadges
              aria-describedby={STRUCTURE_OPTIONS_DESCRIPTION_ID}
              id={QUICK_SEARCH_STRUCTURE_UID}
              onStructureOptionClick={onEdit}
              source="quicksearch"
            />
          </div>
        </div>
      </div>
    </div>
  );
}

PromptStructureAttachment.propTypes = {
  structurePreview: PropTypes.string.isRequired,
  structureName: PropTypes.oneOfType([PropTypes.string, PropTypes.shape({ name: PropTypes.string, isLinearFormula: PropTypes.bool })]),
  onClear: PropTypes.func.isRequired,
  onEdit: PropTypes.func.isRequired,
  removeButtonRef: PropTypes.shape({ current: PropTypes.any }),
};

export default PromptStructureAttachment;
